// 新增报修单
export const columnRules = {
  name: [
    { required: true, message: '报修单名称必填' },
    { min: 2, max: 20, message: '您的输入有误,请重新输入', trigger: 'blur' },
  ],
  repairPriceType: [{ required: true, message: '维修费用类型' }],
  repairDepartmentNo: [{ required: true, message: '报修部门必选' }],
  repairCompanyNo: [{ required: true }],
  repairPersonName: [{ min: 0, max: 10, message: '您的输入有误,请重新输入', trigger: 'blur' }],
  message: [
    { required: true, message: '审核信息必填' },
    { min: 0, max: 50, message: '字数输入有误，请重新输入', trigger: 'blur' },
  ],
  type: [{ required: true, message: '维修类型必选', trigger: 'blur' }],
  location: [
    { required: true, message: '维修地址必填' },
    { min: 2, max: 30, message: '您的输入有误,请重新输入', trigger: 'blur' },
  ],
  content: [
    { required: true, message: '维修内容必填' },
    { min: 2, max: 1500, message: '您的输入有误,请重新输入', trigger: 'blur' },
  ],
  estimatedCost: [
    { min: 0, max: 50, message: '长度在 0 到 50 个字符', trigger: 'blur' },
    {
      pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
      message: '您的输入有误,请重新输入',
    },
  ],
  plan: [{ min: 0, max: 500, message: '长度在 0 到 500 个字符', trigger: 'blur' }],
};
